<template>
<div class="chapter">
<div class="inner_page">
<p class="tx"><br/>
<br/>
<br/></p>
<p class="ser"><img alt="DublinNoir_text_0007_001" id="d14e167" src="Images/DublinNoir_text_0007_001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brue_ISBN9781936070282_epub_ch1_r1.vue?dd1bc674